import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[callTo]",
})
export class CallToDirective {
  @Input("callTo") phone: string;

  @HostListener("click", ["$event"])
  onClick(event: any): void {
    event.stopPropagation();
    window.location.href = "tel:" + this.phone;
  }
}
